export enum SurveyResponseContexts {
  unknown = 0,
  participant = 1,
  respondent = 2
}
